// information took from property applicationKey
export const CASE_CATEGORY = {
  General: 'General',
  Incomplete: 'Incomplete',
  Orthotics: 'Orthotics',
  Prosthetics: 'Prosthetics',
  Rehab: 'Rehab',
  Respiratory: 'Respiratory',
  Wound: 'Wound',
  Other: 'Other'
};

export const PRODUCT_CASE_STATUS = {
  Pending: 'Pending',
  Incomplete: 'Incomplete',
  Cancelled: 'Cancelled',
  Complete: 'Complete',
};

export const REFERENCE_COMPLETE_REMOVE_FROM_QUEUE = 'CompleteRemoveFromQueue';
